import Input from './Input'
import MarginOptions from './MarginOptions'
import RightBarGroup from './RightBarGroup'
import MaxWidthOptions from './MaxWidthOptions'
import {
  FontSizeOptions,
  FontWeightOptions,
  LeadingOptions,
  TextAlignmentOptions,
  TextColorOptions,
} from './TypographyOptions'
import {
  ChangeEvent,
  DynamicContentType,
  HeaderData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<HeaderData>
  setData: (e: ChangeEvent) => void
}

const HeaderEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()
  return (
    <>
      <Input
        light
        label={tr(TrKey.headerEditorTextLabel)}
        placeholder={tr(TrKey.headerEditorTextPlaceholder)}
        type='text'
        name='text'
        id='text'
        value={content.data.text}
        onChange={setData}
      />
      <RightBarGroup title={tr(TrKey.textSettings)} topLine>
        <TextAlignmentOptions content={content} setData={setData} />
        <FontSizeOptions content={content} setData={setData} />
        <FontWeightOptions content={content} setData={setData} />
        <LeadingOptions content={content} setData={setData} />
        <TextColorOptions content={content} setData={setData} />
        <MaxWidthOptions content={content} setData={setData} />
      </RightBarGroup>
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default HeaderEditor
